import { FlexLayout, Input } from '@deity-io/portal-ui';
import type { CreateEditFlowInput } from 'components/Flows/CreateEditFlowModal';
import type { FormikErrors } from 'formik';
import type { FC } from 'react';

interface FormFieldProps {
  errors: FormikErrors<CreateEditFlowInput>;
  values: CreateEditFlowInput;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, isTouched?: boolean | undefined, shouldValidate?: boolean | undefined) => void;
  entity: string;
}

export const EntityNameDescriptionFields: FC<FormFieldProps> = ({
  errors,
  values,
  setFieldValue,
  setFieldTouched,
  entity
}) => (
  <FlexLayout flexDirection="column">
    <Input
      autoFocus
      required
      label="Name"
      type="text"
      name="name"
      id="name"
      value={values.name}
      onBlur={() => setFieldTouched('name', true)}
      onChange={e => setFieldValue('name', e.target.value)}
      placeholder={`${entity} name`}
      error={!!errors.name}
      helperText={errors.name}
      sx={{ marginY: 2 }}
    />

    <Input
      label="Description"
      type="text"
      name="description"
      id="description"
      value={values.description}
      onBlur={() => setFieldTouched('description', true)}
      onChange={e => setFieldValue('description', e.target.value)}
      placeholder={`${entity} description`}
      error={!!errors.description}
      helperText={errors.description}
      sx={{ marginY: 2 }}
    />
  </FlexLayout>
);
